import React, { useRef } from "react";
import { CpdlcTocHeld, cpdlcTocHeldView, useCenterCursor } from "@poscon/shared-frontend";
import { useRootDispatch, useRootSelector } from "~redux/hooks";
import type { Container as PixiContainer } from "pixi.js";
import { viewPositionSelector } from "~redux/slices/eramStateSlice";
import { useDragging } from "hooks/useDragging";
import { layerZIndexMap } from "~/layerZIndexMap";
import { useEventMode } from "components/utils/InteractiveContainer";
import { cpdlcSessionSelector } from "~redux/slices/aircraftSlice";
import { processEramMessage } from "~redux/thunks/processEramMessage";
import { EramAircraftMenuProps } from "../menus/AircraftMenu";
import { setAsel } from "~/redux/slices/eramTempStateSlice";

const view = cpdlcTocHeldView;

export const CpdlcTocHeldPrompt = ({ fp }: EramAircraftMenuProps) => {
  const dispatch = useRootDispatch();
  const ref = useRef<PixiContainer | null>(null);
  const pos = useRootSelector((state) => viewPositionSelector(state, view));
  const { startDrag } = useDragging(ref, view);
  const eventMode = useEventMode();
  const session = useRootSelector((state) => cpdlcSessionSelector(state, fp.id));

  useCenterCursor(ref);

  return fp && session ? (
    <CpdlcTocHeld
      ref={ref}
      pos={pos}
      startDrag={startDrag}
      zIndex={layerZIndexMap.prompts + 1}
      eventMode={eventMode}
      session={session}
      fp={fp}
      dispatchCommand={(command) => dispatch(processEramMessage(command))}
      closeMenu={() => dispatch(setAsel(null))}
    />
  ) : null;
};
